function concat(parts) {
  const size = parts.reduce((total, part) => total + part.length, 0);
  const out = new Uint8Array(size);
  let offset = 0;
  parts.forEach((part) => {
    out.set(part, offset);
    offset += part.length;
  });
  return out;
}

function text(value) {
  return new TextEncoder().encode(value);
}

function buildJpegPdf(jpegBytes, widthPx, heightPx) {
  const maxW = 760;
  const maxH = 500;
  const scale = Math.min(maxW / widthPx, maxH / heightPx, 1);
  const width = Math.max(1, Math.round(widthPx * scale));
  const height = Math.max(1, Math.round(heightPx * scale));
  const pageW = width + 48;
  const pageH = height + 48;
  const content = `q\n${width} 0 0 ${height} 24 24 cm\n/Im1 Do\nQ\n`;
  const header = text("%PDF-1.3\n");
  const objects = [
    text("1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n"),
    text("2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n"),
    text(`3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageW} ${pageH}] /Contents 4 0 R /Resources << /XObject << /Im1 5 0 R >> >> >>\nendobj\n`),
    text(`4 0 obj\n<< /Length ${content.length} >>\nstream\n${content}endstream\nendobj\n`),
    concat([
      text(`5 0 obj\n<< /Type /XObject /Subtype /Image /Width ${widthPx} /Height ${heightPx} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`),
      jpegBytes,
      text("\nendstream\nendobj\n"),
    ]),
  ];
  const chunks = [header];
  const offsets = [0];
  let cursor = header.length;
  objects.forEach((object) => {
    offsets.push(cursor);
    chunks.push(object);
    cursor += object.length;
  });
  const xrefStart = cursor;
  let xref = `xref\n0 6\n0000000000 65535 f \n`;
  for (let index = 1; index <= 5; index += 1) {
    xref += `${String(offsets[index]).padStart(10, "0")} 00000 n \n`;
  }
  xref += `trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF`;
  chunks.push(text(xref));
  return concat(chunks);
}

export function downloadChartPdf(chart, filename) {
  chart.dataURI().then(({ imgURI }) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext("2d");
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0);
      const jpeg = canvas.toDataURL("image/jpeg", 0.92).split(",")[1];
      const binary = atob(jpeg);
      const bytes = new Uint8Array(binary.length);
      for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
      const pdf = buildJpegPdf(bytes, image.width, image.height);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob([pdf], { type: "application/pdf" }));
      link.download = `${filename || "chart"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    };
    image.src = imgURI;
  });
}

export function attachPdfMenu(chart, root, filename) {
  const menu = root && root.querySelector(".apexcharts-menu");
  if (!menu || menu.querySelector(".exportPDF")) return;
  const item = document.createElement("div");
  item.className = "apexcharts-menu-item exportPDF";
  item.title = "Download PDF";
  item.textContent = "Download PDF";
  item.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    menu.classList.remove("apexcharts-menu-open");
    downloadChartPdf(chart, filename);
  });
  menu.appendChild(item);
}
